export enum ActivityLogEvent {
  appointment_canceled = 'appointment_canceled',
  appointment_confirmed = 'appointment_confirmed',
  appointment_scheduled = 'appointment_scheduled',
  appointment_status = 'appointment_status',
  app_open = 'app_open',
  challenge_finished = 'challenge_finished',
  classification_changed = 'classification_changed',
  drug_screen_occured = 'drug_screen_occured',
  engaged = 'engaged',
  episode_of_care_admitted = 'episode_of_care_admitted',
  episode_of_care_discharged = 'episode_of_care_discharged',
  has_completed_reward_card_tutorial = 'has_completed_reward_card_tutorial',
  inbound_message_created = 'inbound_message_created',
  kustomer_note_created = 'kustomer_note_created',
  login = 'login',
  log_in = 'log_in',
  log_out = 'log_out',
  mission_finished = 'mission_finished',
  outbound_message_created = 'outbound_message_created',
  person_merge = 'person_merge',
  person_achievement_created = 'person_achievement_created',
  phase_transition = 'phase_transition',
  program_qualification = 'program_qualification',
  program_qualification_disqualified = 'program_qualification_disqualified',
  program_qualification_intake_rejected = 'program_qualification_intake_rejected',
  referral_created = 'referral_created',
  sign_up = 'sign_up',
  sign_up_complete = 'sign_up_complete',
  survey_partial_completion = 'survey_partial_completion',
  survey_submitted = 'survey_submitted',
  uninstall_detected = 'uninstall_detected',
  work_item_created = 'work_item_created',

  // Deprecated
  APPOINTMENT_CANCELED_EVENT = 'Appointment Canceled Event',
  APPOINTMENT_CONFIRMED_EVENT = 'Appointment Confirmed Event',
  APPOINTMENT_SCHEDULED_EVENT = 'Appointment Scheduled Event',
  APPOINTMENT_STATUS_EVENT = 'Appointment Status Event',
  APP_OPEN_EVENT = 'App Open Event',
  CHALLENGE_FINISHED_EVENT = 'Challenge Finished Event',
  CLASSIFICATION_CHANGED_EVENT = 'Classification Changed Event',
  DRUG_SCREEN_OCCURRED_EVENT = 'Drug Screen Occured Event',
  EPISODE_OF_CARE_ADMITTED = 'Episode of Care Admitted',
  EPISODE_OF_CARE_DISCHARGED = 'Episode of Care Discharged',
  INBOUND_MESSAGE_CREATED_EVENT = 'Inbound Message Created Event',
  LOG_IN_EVENT = 'Log In Event',
  LOG_OUT = 'Log Out',
  MISSION_FINISHED_EVENT = 'Mission Finished Event',
  OUTBOUND_MESSAGE_CREATED_EVENT = 'Outbound Message Created Event',
  PHASE_TRANSITION_EVENT = 'Phase Transition Event',
  PROGRAM_QUALIFICATION_EVENT = 'Program Qualification Event',
  PROGRAM_QUALIFICATION_DISQUALIFIED_EVENT = 'Program Qualification Disqualified Event',
  PROGRAM_QUALIFICATION_INTAKE_REJECTED_EVENT = 'Program Qualification Intake Rejected Event',
  REFERRAL_CREATED_EVENT = 'Referral Created Event',
  SIGN_UP_EVENT = 'Sign Up Event',
  SIGN_UP_COMPLETE_EVENT = 'Sign Up Complete Event',
  SURVEY_PARTIAL_COMPLETION_EVENT = 'Survey Partial Completion Event',
  SURVEY_SUBMITTED_EVENT = 'Survey Submitted Event',
  UNINSTALL_DETECTED_EVENT = 'Uninstall Detected Event',

  // Testing purposes
  TEST_EVENT = 'test_event'
}

export default {};
